/* eslint-disable no-param-reassign */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { DropdownSelectField, InputField, InputNumberField } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import { Icon, DateTimeField, useModal } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import styles from '../../../SPEventLiabilityStyles.module.scss'
import metadata from './EventLocComponent.metadata.json5';

function EventLocComponent(props) {

    const {
        data: EventLocVM,
        updateWizardData,
        submissionVM,
        eventLocPath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useContext(TranslatorContext);
    const { showAlert } = useModal();
    const addEventLoc = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            EventLocVM.value = EventLocVM.value || []

            const { _xCenter, _dtoName } = EventLocVM;

            const EventLocObjVM = viewModelService.create(
                {
                    a1: EventLocVM.value.length + 1,
                    isValidationReq: true
                },
                _xCenter,
                _dtoName
            );

            EventLocObjVM.isValidationReq = true;

            EventLocVM.pushElement(
                EventLocObjVM
            );

            if(EventLocVM.length === 1) {
                EventLocObjVM.addNonPoBoxOnl2 = _.get(submissionVM.value, 'baseData.policyAddress.addressLine1');
                EventLocObjVM.cit3 = _.get(submissionVM.value, 'baseData.policyAddress.city');
                EventLocObjVM.posCod6 = _.get(submissionVM.value, 'baseData.policyAddress.postalCode');
                EventLocObjVM.prov4 = mapCodeToProvince(_.get(submissionVM.value, 'baseData.policyAddress.state'));
            }

            updateWizardData(submissionVM);
        },
        [EventLocVM, viewModelService, updateWizardData, submissionVM]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            if(EventLocVM.value[index].a1 === 1) {
                showAlert({
                    title: 'Can not remove',
                    message: 'Primary Location cannot be removed',
                    status: 'error',
                    icon: 'mi-error-outline'
                }).catch(_.noop);
                
                return
            }

            EventLocVM.value.splice(index, 1);
            EventLocVM?.value?.map((val, index) => val.a1 = index + 1);
            _.set(submissionVM.value, eventLocPath, EventLocVM.value);
            updateWizardData(submissionVM);
        }, [EventLocVM.value, submissionVM, eventLocPath, updateWizardData, showAlert]
    );

    const mapCodeToProvince = useCallback((code) => {
        let province = ''

        switch (code) {

            case 'AB':
                province = 'Alb'
                break;

            case 'BC':
                province = 'BriCol'
                break;

            case 'MB':
                province = 'Man'
                break;

            case 'NB':
                province = 'NewBru'
                break;

            case 'NL':
                province = 'NewAndLab'
                break;

            case 'NT':
                province = 'NorTer'
                break;
            
            case 'NS':
                province = 'NovSco'
                break;

            case 'NU':
                province = 'Nun'
                break;

            case 'ON':
                province = 'Ont'
                break;

            case 'PE':
                province = 'PriEdwIsl'
                break;

            case 'QC':
                province = 'Que'
                break;

            case 'SK':
                province = 'Sas'
                break;

            case 'YT':
                province = 'Yuk'
                break;

            default:
                province = ''
        }

        return province
    }, [])

    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;
            
            item.isValidationReq = true

            if (path === 'a1') {
                const value = item.a1 ? item.a1 : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        value={value}
                        readOnly={true}
                    />
                );
            }

            if (path === 'addNonPoBoxOnl2') {
                const value = item.addNonPoBoxOnl2 ? item.addNonPoBoxOnl2 :
                    (index === 0 ? _.get(submissionVM.value, 'baseData.policyAddress.addressLine1') : '');

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.addNonPoBoxOnl2= val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'cit3') {
                const value = item.cit3 ? item.cit3 :
                    (index === 0 ?_.get(submissionVM.value, 'baseData.policyAddress.city') : '');

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.cit3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'prov4') {
                const value = (item && item.prov4) ? item.prov4 :
                    (index === 0 ?
                        mapCodeToProvince(_.get(submissionVM.value, 'baseData.policyAddress.state'))
                        : undefined);
                const availableValues = EventLocVM.length > 0 && EventLocVM.children[index].pro4
                    ? EventLocVM.children[index].pro4.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.prov4 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }

            if (path === 'posCod6') {
                const value = item.posCod6 ? item.posCod6 :
                    (index === 0 ? _.get(submissionVM.value, 'baseData.policyAddress.postalCode') : '');

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.posCod6 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'staDatTimOfEve') {
                const value = item.staDatTimOfEve ? item.staDatTimOfEve : '';

                return (
                    <DateTimeField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType='string'
                        inputFormat='dd/MM/yyyy'
                        onValueChange={(val, changedPath) => {
                            item.staDatTimOfEve = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        format='vshort'
                    />
                );
            }

            if (path === 'endDatTimOfEve') {
                const value = item.endDatTimOfEve ? item.endDatTimOfEve : '';

                return (
                    <DateTimeField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType='string'
                        inputFormat='dd/MM/yyyy'
                        onValueChange={(val, changedPath) => {
                            item.endDatTimOfEve = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        format='vshort'
                    />
                );
            }

        }, [handleValueChange])

    const removeEventLocTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`EventLocTable`]: {
            data: EventLocVM.value?.sort((a,b) => a.a1 - b.a1)
        }

    }), [EventLocVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addEventLoc,
            getTableCell,
            removeEventLocTableRow
        },
         resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.componentContent,
            EventLocVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [EventLocVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={EventLocVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

EventLocComponent.propTypes = wizardProps;
export default withRouter(EventLocComponent);
